import React, { createContext, useState, ReactNode } from "react";
import { usePrint } from "../utils/hooks/use-print";

interface PrintContextValue {
  isPrint: boolean;
  setIsPrint: (isPrint: boolean) => void;
}

export const PrintContext =
  createContext<PrintContextValue | undefined>(undefined);

interface PrintProviderProps {
  children: ReactNode;
}

export const PrintProvider = ({ children }: PrintProviderProps) => {
  const { isPrint: isMediaPrint } = usePrint();
  const [isPrint, setIsPrint] = useState(isMediaPrint);

  return (
    <PrintContext.Provider
      value={{
        isPrint,
        setIsPrint
      }}
    >
      {children}
    </PrintContext.Provider>
  );
};

export default PrintProvider;
